export default "__VITE_ASSET__009eb257__"